// We use superagent as a default worker
'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _superagent = require('./superagent');

// import SingleObjectResource factory

var _single = require('./single');

var _single2 = _interopRequireDefault(_single);

// Export everything
var GenericResource = _superagent.resource;
exports.GenericResource = GenericResource;

var _init = require('./init');

Object.defineProperty(exports, 'getConfig', {
  enumerable: true,
  get: function get() {
    return _init.getConfig;
  }
});
Object.defineProperty(exports, 'setConfig', {
  enumerable: true,
  get: function get() {
    return _init.setConfig;
  }
});

var _errors = require('./errors');

Object.defineProperty(exports, 'InvalidResponseCode', {
  enumerable: true,
  get: function get() {
    return _errors.InvalidResponseCode;
  }
});
Object.defineProperty(exports, 'ValidationError', {
  enumerable: true,
  get: function get() {
    return _errors.ValidationError;
  }
});
exports['default'] = (0, _single2['default'])(_superagent.resource);


/*****************
 ** WEBPACK FOOTER
 ** ./~/tg-resources/dist/index.js
 ** module id = 1052
 ** module chunks = 1
 **/